<template lang="html">
  <error-page-layout
    color-type="success"
    error-type="Atualização no sistema"
    first-message="Estamos realizando uma manutenção no sistema."
    focus-message="previsão de conclusão:"
    icon="refresh"
    image-name="maintenance.png"
    second-message="Retorne após a"
    title="Estamos em obras para melhor atendê-lo"
    :under-message="expectedRecoveryDate"
  />
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
import { mapState } from 'pinia'

import { useStore as mainUseStore } from '@/store'

export default {
  components: {
    ErrorPageLayout,
  },
  computed: {
    ...mapState(mainUseStore, {
      expectedRecoveryDate: 'getExpectedRecoveryDate',
    }),
  },
  created() {
    this.checkForMaintenance()
  },
  methods: {
    checkForMaintenance() {
      this.$store.dispatch('getStates', ['getLastUpdate']).then(() => {
        this.$router.push('/home').catch(() => {})
      })
    },
  },
}
</script>
